export default __webpack_public_path__ + "static/media/decroly.cc51d6b3.png";